export default __webpack_public_path__ + "static/media/daCrazyRightImg.a36b3649.svg";